import { FC } from 'react'

import { useIsSessionActive } from 'core/auth/authStore'
import { R } from 'core/helpers'
import {
  isForbiddenError,
  isNotFoundError,
  isUnauthorizedError,
  isUnprocessableContentError,
} from 'core/helpers/error'
import { useCompanyGet } from 'core/types'

import ModelLink from './ModelLink'

type CompanyLinkProps = {
  companyId: string
}

const CompanyLink: FC<CompanyLinkProps> = ({ companyId }) => {
  const isSessionActive = useIsSessionActive()

  const {
    data: company,
    isLoading,
    error,
  } = useCompanyGet({
    companyId,
    options: {
      enabled: !!companyId && isSessionActive,
      throwOnError: (error) =>
        R.isNot(isForbiddenError)(error) &&
        R.isNot(isNotFoundError)(error) &&
        R.isNot(isUnprocessableContentError)(error) &&
        R.isNot(isUnauthorizedError)(error),
    },
  })

  // @ts-ignore
  return error?.status === 403 ? (
    `Access restricted: ${companyId}`
  ) : (
    <ModelLink id={companyId} isLoading={isLoading} model={company} />
  )
}

export default CompanyLink
